import { apiMipe, api } from '@/core/api/';
import DocumentsService from '@/modules/shared/documents.api.js';
const apiService = Object.freeze({
  ConvertToByteArray(documentContent) {
    const byteChars = atob(documentContent);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    return byteArray;
  },
  getBlobConvertion(documentFile) {
    const byteArray = apiService.ConvertToByteArray(documentFile.content);
    return new Blob([byteArray], {
      type: documentFile.contentType,
    });
  },
  async ConvertToBlob(documentFile) {
    const blob = apiService.getBlobConvertion(documentFile);

    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  async getDocumentByAttachmentId(attachmentId) {
    return await apiMipe
      .get(`/api/documents/${attachmentId}`)
      .then((response) => {
        return apiService.ConvertToByteArray(response.data.content);
      });
  },
  async getDocumentById(attachmentId) {
    return await api.get(`/api/documents/${attachmentId}`).then((response) => {
      return apiService.ConvertToByteArray(response.data.content);
    });
  },
  async downloadDocument(attachmentId) {
    return apiMipe
      .get(`/api/documents/downloaddocument?id=${attachmentId}`)
      .then((response) => {
        apiService.ConvertToBlob(response.data);
      });
  },
  async downloadDocumentByAttachmentId(attachmentId) {
    return apiMipe.get(`/api/documents/${attachmentId}`).then((response) => {
      apiService.ConvertToBlob(response.data);
    });
  },
  async downloadConsultingDocument(consultingId) {
    return api
      .get(`/api/providerthrpybilling/consulting/document/${consultingId}`)
      .then((response) => {
        apiService.ConvertToBlob(response.data);
      });
  },
  async deleteDocumentByAttachmentId(attachmentId) {
    return apiMipe.delete(`/api/documents/${attachmentId}`);
  },
  async downloadReport(name) {
    return apiService
      .getReport(name)
      .then((response) => {
        apiService.ConvertToBlob(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  getReport(name) {
    return api.get(`/api/report/${name}`);
  },
  async getDashboardAlerts(alertTypeId, pageIndex, pageSize) {
    const url = 'api/alert';
    return apiMipe.get(alertTypeId ? `${url}/${alertTypeId}` : url, {
      params: {
        pageIndex,
        pageSize,
      },
    });
  },
  async getReportsPEIPS(peiId) {
    return await apiMipe.get(`/api/report/pei/${peiId}`).then((res) => {
      const result = res.data;
      if (result) {
        apiService.documentDownloadReport(result.content, result.filename);
      }
    });
  },
  async getReportsProposalProcess(announcementId) {
    return await apiMipe
      .get(`/api/report/proposalprocess/${announcementId}`)
      .then((res) => {
        const result = res.data;
        if (result) {
          apiService.documentDownloadReport(result.content, result.filename);
        }
      });
  },
  async getProposalRequestRP(proposalRequestId) {
    return await apiMipe
      .get(`/api/report/rpproposalrequest/${proposalRequestId}`)
      .then((res) => {
        const result = res.data;
        if (result) {
          apiService.documentDownloadReport(result.content, result.filename);
        }
      });
  },
  documentDownloadReport(content, filename) {
    let binaryString = window.atob(content);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }

    const fileType =
      filename && filename.indexOf('.xls') !== -1
        ? 'application/octet-stream'
        : 'application/pdf';

    let blob = new Blob([bytes], { type: fileType });

    let objectURL = window.URL.createObjectURL(blob);

    let link = document.createElement('a');
    link.href = objectURL;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
  downloadFileInline(file) {
    // Crear un Blob con los datos del archivo
    const blob = new Blob([file], { type: file.type });

    // Crear un enlace temporal
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = file.name; // Nombre con el que se descargará el archivo

    // Agregar el enlace al DOM y hacer clic en él para iniciar la descarga
    document.body.appendChild(downloadLink);
    downloadLink.click();

    // Eliminar el enlace después de la descarga
    document.body.removeChild(downloadLink);
  },
  downloadFile(documentFile) {
    const fr = new FileReader();
    fr.readAsDataURL(documentFile.content);
    const blob = new Blob([documentFile.content], {
      type: documentFile.contentType,
    });

    const objectURL = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectURL;
    link.download = documentFile.filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
  async getDashboardMessages() {
    return await api.get('api/message/mesaggefordashboard');
  },
  async saveReadMessage(messageId) {
    return api.post(`api/message/savemessageread/${messageId}`);
  },
  downloadReportByDocumentFile(documentFile) {
    const byteChars = atob(documentFile.content);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    let blob = new Blob([byteArray], {
      type: documentFile.contentType,
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  async getContractProviderReport(contractId) {
    const response = await api.get(`api/report/providercontract/${contractId}`);
    apiService.ConvertToBlob(response.data);
  },
  async getContractTariffSheetReport({ contractId, format }) {
    const response = await api.get(
      `api/report/contract/${contractId}/tariffsheet?format=${format}`
    );
    apiService.ConvertToBlob(response.data);
  },
  async getBillingPaymentDistributionCertification(paymentId) {
    const response = await api.get(
      `api/report/billingpayment/${paymentId}/distributioncertification`
    );
    apiService.ConvertToBlob(response.data);
  },
  async getTapRequestRefundReport(disbursementRequestId) {
    const response = await api.get(
      `api/disbursementrequest/${disbursementRequestId}/aprovalletter`
    );
    apiService.ConvertToBlob(response.data);
  },
  async getTapRequestDirectPaymentReport(params) {
    const response = await apiMipe.get(`api/report/taprequest/directpayment`, {
      params,
    });
    apiService.ConvertToBlob(response.data);
  },
  async getRefundCertificationReport(params) {
    const response = await apiMipe.get(
      `api/report/taprequest/refundcertification`,
      { params }
    );
    apiService.ConvertToBlob(response.data);
  },
  async getDirectPaymentCertificationReport(params) {
    const response = await apiMipe.get(
      `api/report/reimbursement/directpaymentcertification`,
      { params }
    );
    apiService.ConvertToBlob(response.data);
  },
  async downloadWeeklycompliance(model) {
    return await apiMipe
      .get(`api/report/getweeklycompliance`, {
        params: model,
      })
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },
  async downloadExemptionapprovementlettere(model) {
    return await apiMipe
      .get(`api/report/exemptionapprovementletter`, {
        params: model,
      })
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },
  async downloadInterventionPlanAbsences(admissionId) {
    return await api
      .get(`api/report/interventionplanabsences/${admissionId}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },
  async downloadAdmissionAbsences(admissionId) {
    return await api
      .get(`api/report/admissionabsences/${admissionId}`)
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async getTapRequestPurchaseService(params) {
    return await apiMipe
      .get('api/report/taprequest/purchaseservice', { params })
      .then(({ data }) => {
        DocumentsService.Download(data);
      });
  },

  async getPurchaseService(id) {
    return await api.get(`/api/report/purchaseservice/${id}`).then((res) => {
      const result = res.data;
      if (result) {
        apiService.documentDownloadReport(result.content, result.filename);
      }
    });
  },
  async getDocument(id) {
    const { data } = await apiMipe.get(`/api/documents/${id}`);
    DocumentsService.Download(data);
  },
  async getMedicalPlanConsent(id) {
    const { data } = await apiMipe.get(`api/report/medicalplanconsent/${id}`);
    DocumentsService.Download(data);
  },
  async getSpeechAndLanguajeEvaluationReport(id) {
    const { data } = await api.get(
      `api/report/speechAndLanguajeEvaluationReport/${id}`
    );
    DocumentsService.Download(data);
  },
  async getCms1500ClaimReport(id) {
    const { data } = await api.get(`api/report/cms1500ClaimReport/${id}`);
    DocumentsService.Download(data);
  },
});
export default apiService;
